import { Button } from "@shapr3d/frontend-lib";

import Heading from "../Heading/Heading";

import style from "./AccountDeletionSuccess.module.css";

interface AccountDeletionSuccessProps {
  onBackButton: () => void;
}

const AccountDeletionSuccess = ({ onBackButton }: AccountDeletionSuccessProps) => {
  return (
    <div className={style.container}>
      <div className={style.accountDeletionSuccessContent}>
        <Heading type="h1">Account deleted</Heading>

        <div className={style.paragraph}>
          We deleted your account and all your projects and data connected to it.
        </div>

        <Button variant="grayscale" className={style.backButton} onClick={onBackButton}>
          Back to homepage
        </Button>
      </div>
    </div>
  );
};

export default AccountDeletionSuccess;
